// extracted by mini-css-extract-plugin
export default {"mkt":"Marketplace_mkt__PFHXX"};